import type { StatesRepository } from "../../domain/repositories/StatesRepository";
import type { States } from "../../domain/entities/States";

export const getStates = async (
  repo: StatesRepository,
  countryId: string,
): Promise<States[]> => {
  return repo.getStates(countryId);
};